export default __webpack_public_path__ + "static/media/single-project-page-05-img-12.8bb8b5ac.png";